export const socialLoginFactory =
  (callback) =>
  (provider, invitationToken = null) =>
    invitationToken
      ? openWindow(
          callback,
          `/api/v1/auth/social/signin?provider=${provider}&invitationToken=${invitationToken}`
        )
      : openWindow(callback, `/api/v1/auth/social/signin?provider=${provider}`);

function openWindow(callback, url) {
  const width = 450;
  const height = 730;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  const bc = new BroadcastChannel("auth");
  bc.onmessage = (event) => {
    // handle event.data posted from your popup
    console.debug("bc event received", event);
    callback(event);

    // console.debug("setting token:", event.data.token);
    // setAuthToken(event.data.token);
    // setLocation("/verbatim");
  };
  window.open(
    url,
    "_blank",
    `popup,menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, top=${top}, left=${left}`
  );
}
